module.exports = __webpack_public_path__ + "static/media/latymerCourt5.0b58fd9e.jpg";